import React, { useMemo } from 'react';

import { getSpecialtyName } from '../utils';
import pencil from '../icons/pencilIcon.svg';

const ProductsList = ({ onEditSpecialty, data = [], allowEditRuleCode }) => {
  const sortedData = useMemo(() => {
    return [...data].sort((specialtyA, specialtyB) => {
      const aSpecialty = specialtyA.specialty || {};
      const bSpecialty = specialtyB.specialty || {};
      const bSpecialtyName = bSpecialty.displayName || '';
      const aSpecialtyName = aSpecialty.displayName || '';
      return aSpecialtyName.localeCompare(bSpecialtyName);
    });
  }, [data]);
  return (
    <div className="roles-list">
      {sortedData.map((row, idx) => (
        <div className="flex roles-list-row" key={idx}>
          <div className="role-product-name">{getSpecialtyName(row)}</div>
          <div className="role-routing-rule-name">{row.routingRule && row.routingRule.ruleName}</div>
          <div className="role-rule-id">{row.routingRule && `ID:${row.routingRule.ruleCode}`}</div>
          {allowEditRuleCode && (
            <div className="role-rule-action" onClick={() => onEditSpecialty(row)}>
              <span>Edit</span>
              <img src={pencil} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ProductsList;
